import React, { useEffect, useState } from 'react';
import {
  Drawer, Result, Layout, Radio, Tag, Flex, TreeSelect, Grid, Segmented, Tabs, Card, Image, Typography, Row, Col, theme
} from 'antd';
import { BarsOutlined, ZoomInOutlined, AppstoreOutlined, HistoryOutlined, PercentageOutlined, FireTwoTone } from '@ant-design/icons';

import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import BuyerListProduct from '../../components/BuyerListProduct';
import Cart from '../../components/Cart';
import BuyerListOrder from '../../components/BuyerListOrder';
import BuyerListBill from '../../components/BuyerListBill';
import BuyerListInvoice from '../../components/BuyerListInvoice';
import CartButton from '../../components/CartButton';
import SearchProduct from '../../components/Search';
import Navbar from '../../components/Navbar';
import OrderEditMessage from '../../components/SellerEditOrderView';
import SellerBuyerView from '../../components/SellerBuyerView';
import PagesFooter from '../../components/PagesFooter';
import { axiosClient } from '../../apiClient';
import { gold } from '@ant-design/colors';

const { Content } = Layout;
const { useToken } = theme;
const { useBreakpoint } = Grid;
const { Text, Title } = Typography;

const Catalogo = React.memo(() => {
  const dispatch = useDispatch();
  const { token } = useToken();
  const screens = useBreakpoint();

  const [visibleCart, setVisibleCart] = useState(false);
  const [visibleOrder, setVisibleOrder] = useState(false);
  const [selectedOption, setSelectedOption] = useState('order');
  const [treeData, setTreeData] = useState([]);
  const [viewType, setViewType] = useState('list');
  const [onSaleCount, setOnSaleCount] = useState(null);

  const buyerView = useSelector((state) => state.buyerView.buyerView);
  const logged = useSelector((state) => state.authentication.logged);
  const onlineStatus = useSelector((state) => state.sync.onlineStatus);
  const syncStatus = useSelector((state) => state.sync.syncStatus);
  const dropdownValue = useSelector((state) => state.searchState.categories);
  const campaigns = useSelector((state) => state.campaigns.campaigns);

  const { orderRebuyId } = useParams();

  useEffect(() => setViewType(screens.md ? viewType : "list"), [screens.md])


  useEffect(() => {
    buyerView && axiosClient.post('/products/search', {
      filter: "on_sale",
      only_count: true,
      buyerViewId: buyerView.id,
    }, { withCredentials: true }).then((response) => setOnSaleCount(response?.data?.count || 0))
  }, [buyerView]);

  useEffect(() => {
    if (logged === 'buyer') {
      setViewType('card')
    }
  }, [logged])

  useEffect(() => {
    orderRebuyId && dispatch({ type: 'SET_ORDER_REBUY', orderRebuyId });
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    if (params.has('meus-pedidos')) {
      setSelectedOption('order');
      setVisibleOrder(true);
    }

    if (params.has('minhas-contas')) {
      setSelectedOption('bill');
      setVisibleOrder(true);
    }
  }, []);

  const options = [
    {
      label: 'Orçamentos',
      value: 'quote',
    },
    {
      label: 'Pedidos',
      value: 'order',
    },
    {
      label: 'Contas',
      value: 'bill',
    },
    {
      label: 'Notas',
      value: 'invoice',
    },
  ];

  const fixedCampaigns = [
    {
      id: 'all',
      filterType: 'all',
      name: 'Todos os Produtos',
      value: 'Ver tudo',
      icon: <AppstoreOutlined style={{ fontSize: 32 }} />,
    },
    {
      id: 'rebuy',
      filterType: 'rebuy',
      name: 'Comprados Recentemente',
      value: 'Histórico',
      icon: <HistoryOutlined style={{ fontSize: 32 }} />,
    },
    ...(onSaleCount > 0
      ? [{
        id: 'on_sale',
        filterType: 'on_sale',
        name: 'Produtos com Desconto',
        value: `${onSaleCount} ${onSaleCount === 1 ? 'item' : 'itens'}`,
        icon: <PercentageOutlined style={{ fontSize: 32 }} />,
      }]
      : []),
  ];

  const PromoTabs = () => {
    const [activeTab, setActiveTab] = useState('todos');

    return (
      <Tabs activeKey={activeTab} onChange={setActiveTab} tabBarGutter={8}>
        {[...fixedCampaigns, ...campaigns.map(rule => ({
          ...rule,
          filterType: `campaign_${rule.id}`,
          icon: <FireTwoTone twoToneColor={gold[5]} style={{ fontSize: 32 }} />,
        }))].map((camp) => (
          <Tabs.TabPane
            key={camp.id}
            tab={

              <Card
                hoverable
                onClick={() =>
                  dispatch({ type: 'SET_FILTER_TYPE', filterType: camp.filterType })
                }
                style={{
                  width: 300,
                  height: 75,
                  overflow: 'visible',
                  position: 'relative',        // torna o Card container posicional
                }}
                bodyStyle={{ padding: 6, height: '100%' }}
              >
                {/* Conteúdo atual */}
                <div style={{ height: '100%', display: 'flex', alignItems: 'center' }}>
                  <Row gutter={8} style={{ width: '100%', alignItems: 'center' }}>
                    <Col>
                      {camp.icon ? (
                        <div
                          style={{
                            width: 50,
                            height: 50,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            background: token.colorBgLayout,
                            borderRadius: 4,
                          }}
                        >
                          {camp.icon}
                        </div>
                      ) : (
                        <Image
                          width={50}
                          height={50}
                          src={camp.image}
                          alt={camp.label}
                          style={{ objectFit: 'cover', borderRadius: 4 }}
                          preview={{
                            mask: <ZoomInOutlined style={{ fontSize: 16 }} />,
                          }}
                        />
                      )}
                    </Col>
                    <Col flex="auto">
                      <div
                        style={{
                          display: 'grid',
                          gridTemplateRows: '1fr 1fr 1fr',
                          rowGap: 1,
                          minHeight: 50,
                        }}
                      >
                        <Text
                          type="secondary"
                          ellipsis
                          style={{ maxWidth: 200, lineHeight: '1.1em' }}
                        >
                          {camp.name}
                        </Text>
                        <Text
                          type="primary"
                          ellipsis
                          style={{ maxWidth: 200, lineHeight: '1.1em' }}
                          strong
                        >
                          {camp.value}
                          {camp.action === 'discountCart' && 'Desconto no Pedido'}
                          {camp.action === 'discountProducts' && 'Desconto em Produtos'}
                          {camp.action === 'progressiveDiscount' &&
                            ' Desconto Progressivo'}
                        </Text>
                        <Text
                          type="secondary"
                          ellipsis
                          style={{
                            fontSize: 10,
                            lineHeight: '1em',
                            visibility: camp.validUntil ? 'visible' : 'hidden',
                          }}
                        >
                          {camp.validUntil || ''}
                        </Text>
                      </div>
                    </Col>
                  </Row>
                </div>
                {camp.action && <Tag
                  color="gold"
                  bordered={false}
                  style={{
                    position: 'absolute',
                    bottom: 6,
                    right: 8,
                    fontSize: 10,
                    padding: '0 6px',
                    lineHeight: '16px',
                  }}
                >
                  Campanha
                </Tag>}
              </Card>
            }
          />
        ))}
      </Tabs>
    );
  };


  useEffect(() => {
    axiosClient
      .get('/products/categories/list', { withCredentials: true })
      .then((response) => {
        setTreeData(response.data);
      });
  }, []);


  return (
    (
      <Layout style={{
        backgroundColor: token.customColor2 ?? token.colorBgLayout,
        position: 'absolute', width: '100%', left: '0px', top: '0px',
      }}
      >
        {(logged === 'seller' || logged === 'sellerUser') && (orderRebuyId ? <OrderEditMessage /> : <SellerBuyerView />)}
        <Navbar handleToggle={() => setVisibleOrder(true)} />
        {!onlineStatus && syncStatus != 'synced' && (
          <Result
            style={{ marginTop: '100px' }}
            status="warning"
            title="Você está sem internet e seu aplicativo não está sincronizado"
            subTitle="Conecte seu aparelho na internet e sincronize os dados para usá-lo offline."
          />
        )}
        {(onlineStatus || (syncStatus === 'synced'))

          && (
            <Content>
              <div style={{
                backgroundColor: token.customColor1 ?? token.colorBgContainer,
                borderRadius: token.borderRadius,
                marginTop: (logged === 'seller' || logged === 'sellerUser')
                  ? (screens.md ? 112 + token.marginXXS : 112)
                  : (screens.md ? 60 + token.marginXXS : 60),
                width: '100%',
                overflow: 'hidden',
              }}>
                <Drawer
                  title="Seu Pedido"
                  placement="right"
                  width={window.innerWidth > 375 ? 375 : '100%'}
                  onClose={() => setVisibleCart(false)}
                  open={visibleCart}
                >
                  <Cart />
                </Drawer>
                <Drawer
                  title="Histórico do Cliente"
                  placement="right"
                  width={window.innerWidth > 375 ? 375 : '100%'}
                  onClose={() => setVisibleOrder(false)}
                  open={visibleOrder}
                >
                  <Flex vertical gap="middle">
                    <Radio.Group
                      block
                      options={options}
                      value={selectedOption}
                      onChange={(e) => setSelectedOption(e.target.value)}
                      optionType="button"
                      buttonStyle="solid"
                    />
                  </Flex>
                  {['order', 'quote'].includes(selectedOption) && <BuyerListOrder orderType={selectedOption} />}
                  {selectedOption === 'bill' && <BuyerListBill />}
                  {selectedOption === 'invoice' && <BuyerListInvoice />}
                </Drawer>
                <div
                  style={{
                    padding: '0px 6px',
                  }}
                >
                  <PromoTabs />
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: screens.md ? "row" : "column",
                    gap: 8,
                    padding: '0px 6px',
                  }}
                >
                  <SearchProduct />
                  <TreeSelect
                    showSearch
                    treeNodeFilterProp='title'
                    treeData={treeData}
                    value={dropdownValue}
                    onChange={(categories) => dispatch({ type: 'CATEGORIES_VALUE', categories })}
                    showCheckedStrategy={TreeSelect.SHOW_PARENT}
                    treeCheckable
                    placeholder="Filtre por categorias"
                    style={{ width: '100%' }}
                    size="large"
                    allowClear
                  />
                  {screens.md && <Segmented
                    size='large'
                    onChange={setViewType}
                    value={viewType}
                    options={[
                      {
                        value: 'list',
                        icon: <BarsOutlined />,
                      },
                      {
                        value: 'card',
                        icon: <AppstoreOutlined />,
                      },
                    ]}
                  />}
                </div>
                <BuyerListProduct viewType={viewType} />
                <CartButton handleToggle={() => setVisibleCart(!visibleCart)} />
              </div>
            </Content>
          )}
        <PagesFooter />
      </Layout >
    )
  );
})

export default Catalogo
